import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { ILicense } from '../../../../Interface/license'
import { CurrencySignType, LgType } from '../../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-license-popup-item',
  templateUrl: './bmcore-license-popup-item.component.html',
  styleUrls: ['./bmcore-license-popup-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreLicensePopupItemComponent {
  @Input() lg: LgType
  @Input() trackLicense: ILicense
  @Input() isLicenseActive = false
  @Input() currencySign: CurrencySignType

  @Output() setFeatures = new EventEmitter<string>()

  showFeatures(event: MouseEvent, trackLicenseId: string) {
    event.stopPropagation()
    this.setFeatures.emit(trackLicenseId)
  }
}
